import React from "react";

const TheDeath = () => {
  return <div>TheDeath</div>;
};

export default TheDeath;
